import { A } from '@solidjs/router';
import { Show, type JSX } from 'solid-js';
import { useAuth } from '../lib/AuthContext';
import { theme, toggleTheme } from '../lib/theme';
import { logoSrc } from '../lib/brand';
import { IconButton } from '../ui/Button';
import { Icon, type IconName } from '../ui/Icon';

function NavLink(props: { href: string; icon: IconName; children: JSX.Element }): JSX.Element {
  return (
    <A href={props.href} class="nav__link" activeClass="is-active">
      <Icon name={props.icon} />
      <span>{props.children}</span>
    </A>
  );
}

export function AppShell(props: { children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  return (
    <div class="shell">
      <header class="topbar">
        <div class="topbar__inner">
          <A href="/boxes" class="brand">
            <img class="brand__logo" src={logoSrc()} alt="Trask" width="202" height="66" />
            <span class="brand__app">AI Workbench</span>
          </A>
          <nav class="nav">
            <NavLink href="/boxes" icon="box">
              Boxes
            </NavLink>
            <NavLink href="/stacks" icon="layers">
              Stacks
            </NavLink>
            <NavLink href="/ssh-keys" icon="key">
              SSH keys
            </NavLink>
            <Show when={auth.config.adminEnabled}>
              <NavLink href="/admin/stacks" icon="shield">
                Administration
              </NavLink>
            </Show>
          </nav>
          <div class="topbar__user">
            <IconButton
              label={theme() === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
              onClick={toggleTheme}
            >
              <Icon name={theme() === 'dark' ? 'sun' : 'moon'} size={18} />
            </IconButton>
            <span class="topbar__email truncate">{auth.identity()?.email ?? auth.identity()?.username}</span>
            <IconButton label="Sign out" onClick={() => auth.signOut()}>
              <Icon name="logout" size={18} />
            </IconButton>
          </div>
        </div>
      </header>
      {props.children}
    </div>
  );
}
